import React from 'react';
import { LegalLayout, LegalSection } from './LegalLayout';

export const Privacy = () => {
  return (
    <LegalLayout
      title="Privacy Policy"
      lastUpdated="Last Updated: June 01, 2026"
      testId="privacy-page"
    >
      <LegalSection heading="Introduction" testId="privacy-intro">
        <p>
          Apex Athletic Mind Consulting LLC (&ldquo;Company,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) is committed to protecting your privacy. This Privacy Policy describes how we collect, use, and disclose your personal information when you visit apexathleticmind.com, use the Apex AI Coach app, or engage in our mental performance coaching services.
        </p>
      </LegalSection>

      <LegalSection heading="Information We Collect" testId="privacy-info-collect">
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Direct Information:</strong> Name, email, phone number, athletic background, and payment information provided via Stripe.</li>
          <li><strong>Performance Data:</strong> Responses to the Apex Six assessments, self-reported mindset data, and progress tracking within the Apex AI Coach app.</li>
          <li><strong>Automated Data:</strong> IP addresses, browser types, device type, referring URL, and pages visited collected via cookies and analytics providers (such as Google Analytics).</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Third-Party Processors" testId="privacy-third-party">
        <p>We utilize the following third-party service providers to facilitate our operations:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Payments:</strong> Stripe (PCI-compliant processing).</li>
          <li><strong>Communications:</strong> Resend (email delivery) and Zapier (workflow automation).</li>
          <li><strong>Application Hosting:</strong> Cloud-based servers for the Apex AI Coach app.</li>
          <li><strong>Analytics:</strong> Standard web and app analytics to improve user experience.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Data Rights (NJ, CCPA, GDPR)" testId="privacy-data-rights">
        <p>
          We comply with applicable data protection laws. Users may request access to, correction of, or deletion of their personal data. We will respond to verified requests within thirty (30) days. While we primarily serve the NJ/NY/PA region, we apply these standard protections to all users.
        </p>
      </LegalSection>

      <LegalSection heading="California Privacy Rights (CCPA)" testId="privacy-ccpa">
        <p>
          If you are a California resident, you have the right to request access to your data or its deletion. We do not sell your personal information.
        </p>
      </LegalSection>

      <LegalSection heading="Children’s Privacy" testId="privacy-children">
        <p>
          Our services are often intended for high school and college athletes. For users under the age of 13, we require verifiable parental consent before collecting any personal information.
        </p>
      </LegalSection>

      <LegalSection heading="Contact Information" testId="privacy-contact">
        <div className="bg-white border border-black/8 rounded-xl p-5 shadow-sm">
          <p className="font-semibold text-[#1a1a1a]">Apex Athletic Mind Consulting LLC</p>
          <p className="text-[#3a3a3a]">1820 Chapel Avenue W</p>
          <p className="text-[#3a3a3a]">Suite 300-100A PMB 70263</p>
          <p className="text-[#3a3a3a]">Cherry Hill, NJ 08002</p>
          <p className="text-[#3a3a3a] mt-2">
            Email:{' '}
            <a
              href="mailto:volewis@apexathleticmind.com"
              className="text-[#004C54] font-medium hover:underline"
              data-testid="privacy-contact-email"
            >
              volewis@apexathleticmind.com
            </a>
          </p>
        </div>
      </LegalSection>
    </LegalLayout>
  );
};

export default Privacy;
